export default __webpack_public_path__ + "static/media/guest_08_1_karen_santos.fa99f9a4.png";